<template>
  <!--<div>-->
    <div class="page-content">
      <div class="wifi-message">
        <p class="wifi-message">各項目において初回ダウンロード時10～50MBダウンロードされます。※Wi-Fi推奨</p>
      </div>
      <!-- コンテンツ情報表示前 -->
      <div class="inner" v-if="!contents" />
      <!-- コンテンツ情報あり -->
      <div class="inner" v-else-if="0 < contents.length">
        <div class="card-contents" v-for="detail in contents" :key="detail.contentid">
          <div class="flexcenternowrap" @click="$emit('changeView', 'PurchasedDetail', detail)">
            <div class="cover-image"><img :src="getContentsThumbnailPath(detail.contentid, showScreen) " :alt="detail.content_name"></div>
            <div class="detail-content">
              <div class="flexbetween">
                <div class="content-name font28">{{ detail.content_name }}</div>
              </div>
              <div class="content">
                <div class="rate">
                  <span v-if="detail.progress == 100">★</span>
                </div>
                <div class="progress">
                  <p>学習進捗状況</p>
                  <div class="flexbox">
                    <div class="progress-bar">
                      <div class="data" :style="{ width: detail.progress + '%' }" />
                    </div>
                    <div class="percentage font14">{{ detail.progress }}%</div>
                  </div><!-- flexbox -->
                </div><!-- progress -->
              </div><!-- content -->
              <div class="content-button">
                <button><img src="static/images/icon/png/ar_r_circle_gray.png"></button>
              </div>
            </div><!-- detail-content -->
          </div><!-- flexcenter -->
        </div><!-- card-contents v-for(contents) -->
      </div><!-- inner -->
      <!-- コンテンツ情報なし -->
      <div v-else class="inner">
        <div class="no-contents">
          <div class="align-center">
            <p class="font24">利用可能なコンテンツがありません</p>
          </div>
        </div><!-- no-contents -->
      </div><!-- inner -->
    </div><!-- page-content -->
  <!-- </div> -->
</template>

<script>
import common from '@/mixin/common';
import http from '@/mixin/http';
import * as constants from '@/mixin/constants';

export default {
  name: 'portalList',
  data: function () {
    return {
      contents: null,
      showScreen: 'PortalList',
    }
  },
  mixins: [
    common,
    http,
  ],
  created: function () {
    this.log("PortalList start created");
  },
  mounted: function () {
    this.log("PortalList start mounted");

    // コンテンツ一覧情報を取得し画面に設定する
    this.setContents();
  },
  methods: {
    /**
     * コンテンツ一覧情報を取得し画面に設定する
     */
    setContents: function () {
      var self = this;
      this.log("PortalList start setContents");
      this.contents = null;

      // コンテンツ情報一覧取得APIを実行
      this.getContentList().then(function (response) {
        self.log("PortalList getContentList result_code: " + response.result_code);
        switch (response.result_code) {
          case 'OK':
            self.contents = [];
            var push = Array.prototype.push;
            for (var category of response.categories) {
              push.apply(self.contents, category.contents.filter(function (content) { return self.isVisibleContent(content); }));
            }
            break;
          case 'INFO_INVALID_ACCESSKEY':
            self.showErrorInvalidAccessKey();
            break;
          default:
            self.contents = [];
            break;
        }
      }).catch(function (err) {
        self.log("PortalList setContents error");
        self.contents = [];
      });
    },
    /**
     * コンテンツを画面に表示するか否かを返す
     *
     * @param {Object} content コンテンツ情報
     * @return {Boolean} true：表示する, false：表示しない
     */
    isVisibleContent: function (content) {
      return constants.CONTENTS_DOCOMO_ANDROID.some(function (docomo) { return content.contentid == docomo; });
    },
    /**
     * アクセスキー無効エラーダイアログ表示
     */
    showErrorInvalidAccessKey: function () {
      var message = "INFO_INVALID_ACCESSKEY";
      var buttonKind = constants.ERROR_BUTTON_KIND_LOGIN;
      this.$emit('showError', message, buttonKind);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/assets/style/common';
@import 'src/assets/style/study_list';
</style>



// WEBPACK FOOTER //
// PortalList.vue?1d0f7502